import { createAsyncThunk } from "@reduxjs/toolkit";
import AxiosDefaultSetting from "../AxiosDefault";

export const orgStructure = createAsyncThunk(
  "auth/organizationalStructure",
  async (data, { rejectWithValue }) => {
    const { search_text, location_id, ...rest } = data;
    const queryString = new URLSearchParams({
      search_text,
      location_id,
    }).toString();
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/units/chart?${queryString}`, //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//add unit
export const orgAddUnit = createAsyncThunk(
  "auth/addUnit",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "POST",
        url: "/units", //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
//get unit options
export const getUnit = createAsyncThunk(
  "auth/getunit",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: "/units", //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
//delete unit
export const deleteUnit = createAsyncThunk(
  "unit/delete",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "DELETE",
        url: `/units/${id}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
//get location options data
export const getLocation = createAsyncThunk(
  "auth/locations",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: "/locations", //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

//updatead org staructure
export const updateOrgUnit = createAsyncThunk(
  "org/updateorgUnit",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "PUT",
        url: `/units/${id}`, //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//get foreign_language options
export const getForeignLangugeOptions = createAsyncThunk(
  "org/foreignoptions",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/codebooks/${data.type}`, //endpoint
        //data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

//get educational_qualification options data

export const getEducationalOptions = createAsyncThunk(
  "org/education",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/codebooks/${data.type}`, //endpoint
        //data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
//get required_knowledge_and_skill_id  options data

export const getrequiredKnowledgeAndSkilloptions = createAsyncThunk(
  "org/skilloptions",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/codebooks/${data.type}`, //endpoint
        //data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

//special requirement
export const getSpecialRequiremntOptions = createAsyncThunk(
  "org/specialrequirment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/codebooks/${data.type}`, //endpoint
        //data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
//add job postion
export const orgAddJobPosition = createAsyncThunk(
  "auth/addjobpositions",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "POST",
        url: "/job-positions", //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

//update job position
export const updateJobPostion = createAsyncThunk(
  "org/updateJobpostion",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "PUT",
        url: `/job-positions/${id}`, //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
//get jobpostion by id
export const jobPostionGetByid = createAsyncThunk(
  "org/jobbyid",
  async ({ id, data }, { rejectWithValue }) => {
    const { location_id = "", ...rest } = data;
    const queryString = new URLSearchParams({
      location_id,
    }).toString();
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/job-positions/${id}?${queryString}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//get all jobpostions
export const getJobPositions = createAsyncThunk(
  "org/jobPositions",
  async () => {
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/job-positions`,
      });
      return response.data;
    } catch (error) {
      return error.message;
    }
  }
);

//get available job positions
export const getAvailableJobPositions = createAsyncThunk(
  "org/availableJobPositions",
  async (data, { rejectWithValue }) => {
    const { unit_id = "", job_position_id = "", ...rest } = data;
    const queryString = new URLSearchParams({
      unit_id,
      job_position_id,
    }).toString();
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/available-job-positions?${queryString}`,
      });
      return response.data;
    } catch (error) {
      return error.message;
    }
  }
);

//delete job postions
export const deletejobPostion = createAsyncThunk(
  "org/deletejobpostions",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "DELETE",
        url: `/job-positions/${id}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//import file upload data
export const addorgFile = createAsyncThunk(
  "org/file",
  async (data, { rejectWithValue }) => {
    console.log(data, "data");
    try {
      const response = await AxiosDefaultSetting({
        method: "POST",
        url: "/import-units", //endpoint
        data: data,
        contentType: "multipart/form-data",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

//import job positions
export const addJobPosition = createAsyncThunk(
  "org/jobpositionsfile",
  async (data, { rejectWithValue }) => {
    console.log(data, "data");
    try {
      const response = await AxiosDefaultSetting({
        method: "POST",
        url: "/import-job-positions", //endpoint
        data: data,
        contentType: "multipart/form-data",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

//get unit saleSectore unit
export const getUnitSaleSectore = createAsyncThunk(
  "auth/getunitsaleSectore",
  async ({ id, data }, { rejectWithValue }) => {
    console.log(id, data);
    const { location_id, ...rest } = data;
    const queryString = new URLSearchParams({
      location_id,
    }).toString();
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/units/${id}?${queryString}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

//job postions details view
export const jobPostiondetailsview = createAsyncThunk(
  "org/jobdetails",
  async ({ id, data }, { rejectWithValue }) => {
    const { location_id = "", ...rest } = data;
    const queryString = new URLSearchParams({
      location_id,
    }).toString();
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/job-positions/${id}?${queryString}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//get verstion history
export const getverstionhistory = createAsyncThunk(
  "org/getverstion",
  async (data, { rejectWithValue }) => {
    const { year_filter = "" } = data;
    const queryString = new URLSearchParams({
      year_filter,
    }).toString();
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/systematizations?${queryString}`, //endpoint
        //data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

//update current verstions
export const updatecurrentVerstions = createAsyncThunk(
  "org/updateverstions",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "PUT",
        url: `/systematizations/${id}/official-version`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get version parameter values
export const getVersionParameterValues = createAsyncThunk(
  "org/versionParameterValues",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/systematizations/${id}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

//get users
export const getAllUserProfiles = createAsyncThunk(
  "usersManagement/getAllUserProfiles",
  async (data, { rejectWithValue }) => {
    let queryString = "";
    if (data) {
      const {
        order_type = "",
        order_by = "",
        page_size = "",
        page = "",
        search_text = "",
        full_name = "",
        unit_id = "",
        job_position_id = "",
        email = "",
        phone = "",
        contract_start = "",
        contract_end = "",
        is_active = "",
        location_id = "",
        citizenship = "",
        contract_type_id = "",
        ...rest
      } = data;

      queryString = new URLSearchParams({
        order_type,
        order_by,
        page_size,
        page,
        search_text,
        full_name,
        unit_id,
        job_position_id,
        email,
        phone,
        contract_start,
        contract_end,
        is_active,
        location_id,
        citizenship,
        contract_type_id,
      }).toString();
    }

    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/user-profiles?${queryString}`, //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//get user profile by id
export const getUserProfileById = createAsyncThunk(
  "org/byid",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/user-profiles/${data}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//update user profile
export const updateUserProfile = createAsyncThunk(
  "org/updateUsersProfile",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "PUT",
        url: `/user-profiles/${data?.id}`, //endpoint
        data: data?.payload,
        // contentType: "multipart/form-data",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
export const deleteUserProfile = createAsyncThunk(
  "orgStructure/deleteUserProfile",
  async (employeeId, { rejectWithValue }) =>{
    try{
      const response = await AxiosDefaultSetting({
        method: "DELETE",
        url: `/user-profiles/${employeeId}`,
      });
      return response.data;
    }catch (error) {
      return rejectWithValue(error?.response?.data || "Delete Failed");
    }
  }
);
//get disciplinary measures by id
export const getDisciplinaryMeasureById = createAsyncThunk(
  "org/DisciplinaryMeasureById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/user-disciplinary-measures/${id}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//get disciplinary measures
export const getDisciplinaryMeasures = createAsyncThunk(
  "org/DisciplinaryMeasures",
  async (data, { rejectWithValue }) => {
    const {
      order_type = "",
      order_by = "",
      page_size = "",
      page = "",
      user_id = "",
      ...rest
    } = data;
    const queryString = new URLSearchParams({
      order_type,
      order_by,
      page_size,
      page,
      user_id,
    }).toString();
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/user-disciplinary-measures?${queryString}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//get benefits
export const getBenefits = createAsyncThunk(
  "org/benefits",
  async (data, { rejectWithValue }) => {
    const {
      order_type = "",
      order_by = "",
      page_size = "",
      page = "",
      user_id = "",
      search_text = "",
      ...rest
    } = data;
    const queryString = new URLSearchParams({
      order_type,
      order_by,
      page_size,
      page,
      user_id,
      search_text,
    }).toString();
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/user-benefits?${queryString}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//get contracts
export const getContracts = createAsyncThunk(
  "org/contracts",
  async (data, { rejectWithValue }) => {
    const {
      order_type = "",
      order_by = "",
      page_size = "",
      page = "",
      user_id = "",
      ...rest
    } = data;
    const queryString = new URLSearchParams({
      order_type,
      order_by,
      page_size,
      page,
      user_id,
    }).toString();
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/user-contracts?${queryString}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//get userProfiles chart data
export const getUsersChart = createAsyncThunk(
  "org/chart",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/user-profiles/chart`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//get work shifts
export const getWorkShifts = createAsyncThunk(
  "org/workShifts",
  async (data, { rejectWithValue }) => {
    const {
      order_type = "",
      order_by = "",
      page_size = "",
      page = "",
      is_active = "",
      ...rest
    } = data;
    const queryString = new URLSearchParams({
      order_type,
      order_by,
      page_size,
      page,
      is_active,
    }).toString();
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/work-shifts?${queryString}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//get single leave data
export const getWorkShiftById = createAsyncThunk(
  "workShift/getSingle",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/work-shifts/${id}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// Add work shift
export const addWorkShift = createAsyncThunk(
  "workShift/add",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "POST",
        url: "/work-shifts", //endpoint for adding a work shift
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// Update work shift data
export const updateWorkShift = createAsyncThunk(
  "workShift/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "PUT",
        url: `/work-shifts/${id}`, //endpoint for updating a work shift
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// Delete work shift
export const deleteWorkShift = createAsyncThunk(
  "workShift/delete",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "DELETE",
        url: `/work-shifts/${id}`, //endpoint for deleting a work shift
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

export const getUserAttendances = createAsyncThunk(
  "org/user-attendance",
  async ({ type = "all", ...data }, { rejectWithValue }) => {
    let queryString = "";
    if (data) {
      const {
        user_profile_id = "",
        start_date = "",
        end_date = "",
        today = "",
        status = "",
        job_position_id = "",
        unit_id = "",
        location_id = "",
        calendar_overview = "",
        page = 1,
        page_size = 10,
        order_by = "created_at",
        order_type = "desc",
      } = data;

      queryString = new URLSearchParams({
        user_profile_id,
        start_date,
        end_date,
        today,
        status,
        job_position_id,
        unit_id,
        location_id,
        calendar_overview,
        page,
        page_size,
        order_by,
        order_type,
      }).toString();
    }

    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/user-attendances?${queryString}`,
        data: data,
      });

      return { type, data: response.data };
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

const createQueryString = (data = {}) => {
  const {
    page = 1,
    page_size = 10,
    order_by = "created_at",
    order_type = "desc",
    user_profile_id = "",
    start_date = "",
    end_date = "",
    status = "",
    job_position_id = "",
    unit_id = "",
    absence_type_id = "",
    calendar_overview = "",
    ...rest
  } = data;

  return new URLSearchParams({
    user_profile_id,
    start_date,
    end_date,
    status,
    job_position_id,
    unit_id,
    calendar_overview,
    page,
    page_size,
    order_by,
    order_type,
    ...rest,
  }).toString();
};

// Generalized thunk for fetching user absences
export const getUserAbsences = createAsyncThunk(
  "org/user-absences",
  async ({ queryParams, type = "all" }, { rejectWithValue }) => {
    try {
      const queryString = createQueryString(queryParams);
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/user-absences?${queryString}`,
      });
      return { data: response.data, type };
    } catch (error) {
      return rejectWithValue({ error: error?.response?.data?.message, type });
    }
  }
);

// Updating user absences
export const resolveUserAbsenceRequest = createAsyncThunk(
  "org/user-absences",
  async ({ id, data }, { rejectWithValue }) => {
    const formData = new FormData();

    if (data && Object.keys(data).length > 0) {
      Object.keys(data).forEach((key) => formData.append(key, data[key]));
    }

    try {
      const response = await AxiosDefaultSetting({
        method: "PUT",
        url: `/user-absences/${id}`,
        data: formData,
        contentType: "multipart/form-data",
      });
      return { data: response.data };
    } catch (error) {
      return rejectWithValue({ error: error?.response?.data?.message });
    }
  }
);
